export { default as DocumentTextOutlineIcon } from './DocumentTextOutlineIcon';
